import React, { Suspense } from 'react';
import ErrorBoundary from '../../components/error-boundary';
// Imports Components
import Loading from '../../components/loading/loading';
import { lazyWithRetry } from '../../components/lazyLoading/index.js';
// Lazy Components
const CorporateLazy = lazyWithRetry(() => import('./index.jsx'));

const CorporateAccounts = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <CorporateLazy />
      </Suspense>
    </ErrorBoundary>
  );
};
export default CorporateAccounts;
